import { User } from 'oidc-client-ts';

import { getEmail, getFirstName, getSurName, getUserId } from './shared/utils/user';
import { isNullOrWhiteSpaces } from './shared/utils/strings';

const sha256 = async (value: string): Promise<string> => {
  if (!value) return '';
  const data = new TextEncoder().encode(value.toLowerCase().trim());
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hashBuffer))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
};

/**
 * Builds FbqUserData from an OIDC user for Meta Pixel Advanced Matching.
 * Email, first name, and last name are SHA-256 hashed as required by Meta.
 * external_id (sub claim) is sent as-is.
 */
export const getFbqUserData = async (options: {
  user?: User | null | undefined;
  data?: {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
  };
}): Promise<FbqUserData> => {
  if (!options?.user && !options?.data) return {};

  const [em, fn, ln] = await Promise.all([
    sha256(!isNullOrWhiteSpaces(options?.data?.email) ? options!.data!.email : getEmail(options.user)),
    sha256(!isNullOrWhiteSpaces(options?.data?.firstName) ? options!.data!.firstName : getFirstName(options.user)),
    sha256(!isNullOrWhiteSpaces(options?.data?.lastName) ? options!.data!.lastName : getSurName(options.user))
  ]);

  return {
    external_id: !isNullOrWhiteSpaces(options?.data?.id) ? options!.data!.id : getUserId(options.user), // OIDC sub — no hashing needed
    em,
    fn,
    ln
  };
};
